import { render } from "./Contact.vue?vue&type=template&id=25ab314a"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
script.render = render

export default script